import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getStep } from "containers/CreateWizard/reducer";
import * as setupReducer from "containers/Setup/reducer";

import ChooseOptions from "components/CreateWizard/Target/ChooseOptions";

const bId = "chooseOptions";

class ChooseOptionsContainer extends React.PureComponent {
  render() {
    const { step, index } = this.props;

    return <ChooseOptions {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateHumanUnderstandable: (humanUnderstandable) =>
    dispatch(setupReducer.updateHumanUnderstandable(ownProps.id, humanUnderstandable)),
  updateAuditable: (auditable) => dispatch(setupReducer.updateAuditable(ownProps.id, auditable)),
  updateRealTimeResults: (realTimeResults) =>
    dispatch(setupReducer.updateRealTimeResults(ownProps.id, realTimeResults)),
  updateUseModelList: (useModelList) => dispatch(setupReducer.updateUseModelList(ownProps.id, useModelList))
});

const mapStateToProps = (state, ownProps) => ({
  step: getStep(state),
  humanUnderstandable: setupReducer.getHumanUnderstandable(state, ownProps.id),
  auditable: setupReducer.getAuditable(state, ownProps.id),
  realTimeResults: setupReducer.getRealTimeResults(state, ownProps.id),
  useModelList: setupReducer.getUseModelList(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChooseOptionsContainer);
